export default __webpack_public_path__ + "static/media/16-Deezer-White.aff47a08.png";